module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2DROu"))).then(() => parcelRequire('d0iPb'));